import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSubCategories } from "../../actions/homeAction";
import textWeight from "../../utils/textWeight";

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedSubCategoryIds, setSelectedSubCategoryIds] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const { TextWeight } = textWeight();
  const parentId = useSelector((state) => state.app.categoryData.categoryData);
  const {
    data: subCategories,
    isLoading,
    isError,
    error,
  } = useSubCategories(currentPage, parentId?.categoryId, 12);

  useEffect(() => {
    const newTotalItems = subCategories?.pagination?.totalItems;
    if (newTotalItems && newTotalItems !== totalItems) {
      setTotalItems(newTotalItems);
    }
    localStorage.setItem("selectedSubCategoryIds", selectedSubCategoryIds);
    dispatch({
      type: "UPDATE_SUBCATEGORY_IDS",
      payload: { subCategoryIds: selectedSubCategoryIds },
    });
    if (subCategories?.data?.length === 0 && currentPage > 1) {
      setCurrentPage(1);
    }
  }, [
    subCategories,
    totalItems,
    selectedSubCategoryIds,
    subCategories,
    currentPage,
  ]);

  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const itemsPerPage = 12;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  return {
    navigate,
    isLoading,
    subCategories,
    selectedSubCategoryIds,
    setSelectedSubCategoryIds,
    totalItems,
    currentPage,
    totalPages,
    handlePageChange,
    dispatch,
    TextWeight,
  };
};
